import type { ErrorComponentProps } from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';

export default function ErrorComponent({ error }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <div>
      <h2>Something went wrong</h2>
      <p>{error.message}</p>
      <button
        type="button"
        onClick={() => {
          router.invalidate();
        }}
      >
        Try Again
      </button>
    </div>
  );
}
